<template>
	<div class="num-spinner">
		<i class="icon-minus minu-btn"></i>
		<input type="text"  readonly="readonly" value="1">
		<i class="icon-add add-btn"></i>
	</div>
</template>
<script>
	export default {
		name: 'numSpinner'
	}
</script>


// WEBPACK FOOTER //
// src/components/numSpinner/numSpinner.vue